import { useCallback, useEffect, useState } from 'react';
import { fetchClientCompletedJobs } from '../../../services/api';

const normalizeCompletedJob = (item) => {
  const job = item?.job || {};
  const workers = Array.isArray(item?.workers)
    ? item.workers.map((entry) => ({
      ...(entry?.worker || {}),
      ...entry,
      worker: entry?.worker || {},
    }))
    : [];

  return {
    ...job,
    workers,
    workerCount: item?.workerCount ?? workers.length,
    requiredPeople: item?.requiredPeople ?? job.requiredPeople,
    completedWorkerCount: item?.completedWorkerCount ?? 0,
    allWorkersCompleted: item?.allWorkersCompleted ?? false,
    originalJob: job,
  };
};

function useClientCompletedJobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetchClientCompletedJobs();
      const data = Array.isArray(response) ? response : response?.data;
      setJobs(Array.isArray(data) ? data.map(normalizeCompletedJob) : []);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { jobs, loading, error, reload };
}

export default useClientCompletedJobs;